import { Quaternion } from 'three'

export function quatYToDeg(q: Quaternion): number {
  const yaw = Math.atan2(2 * (q.w * q.y + q.x * q.z), 1 - 2 * (q.y * q.y + q.z * q.z))
  return yaw * (180 / Math.PI)
}

export function quatXToDeg(q: Quaternion): number {
  const pitch = Math.asin(2 * (q.w * q.x - q.y * q.z))
  return pitch * (180 / Math.PI)
}

export function quatZToDeg(q: Quaternion): number {
  const roll = Math.atan2(2 * (q.w * q.z + q.x * q.y), 1 - 2 * (q.z * q.z + q.x * q.x))
  return roll * (180 / Math.PI)
}
